export default __webpack_public_path__ + "static/media/ico_equal_co2.34cbfa98.svg";